var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGapsFull = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "-897 479.5 123.4 123.4",
    style: {
      enableBackground: "new -897 479.5 123.4 123.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.57;stroke-miterlimit:22.93;display:none;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{display:none;}\r\n\t.st3{display:inline;stroke:#000000;stroke-width:0.57;stroke-miterlimit:22.93;}\r\n\t.st4{display:inline;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "shutter"), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -840.5,
    cy: 540.7,
    r: 42.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -863.8,
    y1: 519.7,
    x2: -819,
    y2: 518.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-863.8,519.7c0,0,0.7-0.4,1.9-1c0.6-0.3,1.3-0.7,2.2-1c0.4-0.2,0.9-0.4,1.3-0.6c0.2-0.1,0.5-0.1,0.7-0.1 c0.3,0,0.5,0,0.8,0c4.2-0.1,9.8-0.2,15.4-0.3c5.6-0.1,11.2-0.2,15.4-0.3c0.3,0,0.5,0,0.8,0c0.3-0.1,0.5-0.1,0.7,0.1 c0.5,0.2,0.9,0.4,1.4,0.5c0.9,0.3,1.6,0.7,2.2,0.9c1.2,0.5,1.9,0.9,1.9,0.9s-0.7,0.4-1.9,1c-0.6,0.3-1.3,0.6-2.2,1 c-0.4,0.2-0.9,0.4-1.3,0.6c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.8,0c-4.2,0.1-9.8,0.2-15.4,0.3c-5.6,0.1-11.2,0.2-15.4,0.3 c-0.3,0-0.5,0-0.8,0c-0.3,0.1-0.5,0.1-0.7,0c-0.5-0.2-0.9-0.4-1.4-0.5c-0.9-0.3-1.6-0.7-2.2-0.9 C-863.1,520.1-863.8,519.7-863.8,519.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -864.2,
    y1: 541.1,
    x2: -819.4,
    y2: 540.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-864.2,541.1c0,0,0.7-0.4,1.9-1c0.6-0.3,1.3-0.7,2.2-1c0.4-0.2,0.9-0.4,1.3-0.6c0.2-0.1,0.5-0.1,0.7-0.1 c0.3,0,0.5,0,0.8,0c4.2-0.1,9.8-0.2,15.4-0.3s11.2-0.2,15.4-0.3c0.3,0,0.5,0,0.8,0c0.3-0.1,0.5-0.1,0.7,0.1 c0.5,0.2,0.9,0.4,1.4,0.5c0.9,0.3,1.6,0.7,2.2,0.9c1.2,0.5,1.9,0.9,1.9,0.9s-0.7,0.4-1.9,1c-0.6,0.3-1.3,0.6-2.2,1 c-0.4,0.2-0.9,0.4-1.3,0.6c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.8,0c-4.2,0.1-9.8,0.2-15.4,0.3c-5.6,0.1-11.2,0.2-15.4,0.3 c-0.3,0-0.5,0-0.8,0c-0.3,0.1-0.5,0.1-0.7,0c-0.5-0.2-0.9-0.4-1.4-0.5c-0.9-0.3-1.6-0.7-2.2-0.9 C-863.5,541.4-864.2,541.1-864.2,541.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -863,
    y1: 561.7,
    x2: -818.2,
    y2: 560.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-863,561.7c0,0,0.7-0.4,1.9-1c0.6-0.3,1.3-0.7,2.2-1c0.4-0.2,0.9-0.4,1.3-0.6c0.2-0.1,0.5-0.1,0.7-0.1 c0.3,0,0.5,0,0.8,0c4.2-0.1,9.8-0.2,15.4-0.3c5.6-0.1,11.2-0.2,15.4-0.3c0.3,0,0.5,0,0.8,0c0.3-0.1,0.5-0.1,0.7,0.1 c0.5,0.2,0.9,0.4,1.4,0.5c0.9,0.3,1.6,0.7,2.2,0.9c1.2,0.5,1.9,0.9,1.9,0.9s-0.7,0.4-1.9,1c-0.6,0.3-1.3,0.6-2.2,1 c-0.4,0.2-0.9,0.4-1.3,0.6c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.8,0c-4.2,0.1-9.8,0.2-15.4,0.3c-5.6,0.1-11.2,0.2-15.4,0.3 c-0.3,0-0.5,0-0.8,0c-0.3,0.1-0.5,0.1-0.7,0c-0.5-0.2-0.9-0.4-1.4-0.5c-0.9-0.3-1.6-0.7-2.2-0.9C-862.3,562.1-863,561.7-863,561.7 z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -838.3,
    cy: 537.5,
    r: 42.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -854.8,
    y1: 537.3,
    x2: -823.7,
    y2: 505
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-854.8,537.3c0,0,0.2-0.8,0.6-2.1c0.2-0.6,0.5-1.4,0.8-2.3c0.2-0.4,0.4-0.9,0.6-1.4c0.1-0.2,0.3-0.4,0.5-0.6 c0.2-0.1,0.4-0.3,0.6-0.5c2.9-3,6.8-7.1,10.7-11.1c3.9-4,7.8-8.1,10.7-11.1c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.2,0.3-0.4,0.6-0.5 c0.5-0.2,0.9-0.4,1.3-0.6c0.8-0.4,1.6-0.7,2.2-0.9c1.3-0.5,2-0.7,2-0.7s-0.2,0.8-0.7,2c-0.2,0.6-0.5,1.4-0.8,2.3 c-0.2,0.4-0.4,0.9-0.5,1.4c-0.1,0.3-0.2,0.4-0.5,0.6c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9,3-6.8,7.1-10.7,11.1c-3.9,4-7.8,8.1-10.7,11.1 c-0.2,0.2-0.4,0.4-0.5,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.5,0.2-0.9,0.4-1.3,0.6c-0.8,0.4-1.6,0.7-2.2,0.9 C-854.1,537.1-854.8,537.3-854.8,537.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -855.2,
    y1: 553.6,
    x2: -824.1,
    y2: 521.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-855.2,553.6c0,0,0.2-0.8,0.6-2.1c0.2-0.6,0.5-1.4,0.8-2.3c0.2-0.4,0.4-0.9,0.6-1.4c0.1-0.2,0.3-0.4,0.5-0.6 c0.2-0.1,0.4-0.3,0.6-0.5c2.9-3,6.8-7.1,10.7-11.1c3.9-4,7.8-8.1,10.7-11.1c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.2,0.3-0.4,0.6-0.5 c0.5-0.2,0.9-0.4,1.3-0.6c0.8-0.4,1.6-0.7,2.2-0.9c1.3-0.5,2-0.7,2-0.7s-0.2,0.8-0.7,2c-0.2,0.6-0.5,1.4-0.8,2.3 c-0.2,0.4-0.4,0.9-0.5,1.4c-0.1,0.3-0.2,0.4-0.5,0.6c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9,3-6.8,7.1-10.7,11.1c-3.9,4-7.8,8.1-10.7,11.1 c-0.2,0.2-0.4,0.4-0.5,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.5,0.2-0.9,0.4-1.3,0.6c-0.8,0.4-1.6,0.7-2.2,0.9 C-854.4,553.4-855.2,553.6-855.2,553.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -853.9,
    y1: 568.2,
    x2: -822.8,
    y2: 536
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-853.9,568.2c0,0,0.2-0.8,0.6-2.1c0.2-0.6,0.5-1.4,0.8-2.3c0.2-0.4,0.4-0.9,0.6-1.4c0.1-0.2,0.3-0.4,0.5-0.6 c0.2-0.1,0.4-0.3,0.6-0.5c2.9-3,6.8-7.1,10.7-11.1c3.9-4,7.8-8.1,10.7-11.1c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.2,0.3-0.4,0.6-0.5 c0.5-0.2,0.9-0.4,1.3-0.6c0.8-0.4,1.6-0.7,2.2-0.9c1.3-0.5,2-0.7,2-0.7s-0.2,0.8-0.7,2c-0.2,0.6-0.5,1.4-0.8,2.3 c-0.2,0.4-0.4,0.9-0.5,1.4c-0.1,0.3-0.2,0.4-0.5,0.6c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9,3-6.8,7.1-10.7,11.1c-3.9,4-7.8,8.1-10.7,11.1 c-0.2,0.2-0.4,0.4-0.5,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.5,0.2-0.9,0.4-1.3,0.6c-0.8,0.4-1.6,0.7-2.2,0.9 C-853.2,568-853.9,568.2-853.9,568.2z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGapsFull, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gapsFull.319fc884.svg";
export { ForwardRef as ReactComponent };